import { isNil } from "lodash-es";
import pluralize from "pluralize";

export const CountCell = ({ count, label }) =>
  isNil(count) || count === 0 ? `No ${pluralize.plural(label)}` : pluralize(label, count, true);
